import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams } from 'types';
import { KioskEventRetrieve, PaginatedEligibleAthleteList } from 'types/generated';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface IUseEventsType {
  selectedEvent: KioskEventRetrieve | undefined;
  search: string;
  enabled: boolean;
}

function useEligibleAthletes({
  selectedEvent,
  search,
  enabled,
}: IUseEventsType): UseInfiniteQueryResult<AxiosResponse<PaginatedEligibleAthleteList>> {
  const classId = selectedEvent?.eventType === 'kilo_class_type' ? selectedEvent?.eventId : '';

  const fetchEligibleAthletes = ({
    pageParam = { limit: '10', offset: '0' } as UrlParams,
  }): Promise<AxiosResponse<PaginatedEligibleAthleteList>> => {
    const params = pageParam;

    if (classId) {
      params.class = classId;
    }

    if (search) {
      params.search = search;
    }

    return client.get(`athletes/eligible-athletes?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['eligible-athletes', selectedEvent, search], fetchEligibleAthletes, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
    enabled: !!selectedEvent && !!classId && enabled,
  });
}

export default useEligibleAthletes;
